import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { downloadFile } from "../../../utils/file.upload";
import { toast } from "react-toastify";
const AntiVirusScan = t0 => {
  const $ = _c(19);
  const {
    onClose,
    fileToDownload,
    setFileToDownload
  } = t0;
  const [load, setLoad] = useState(false);
  useDispatch();
  let t1;
  if ($[0] !== fileToDownload?.file || $[1] !== fileToDownload?.fileName || $[2] !== setFileToDownload) {
    t1 = async () => {
      setLoad(true);
      const response = await downloadFile(fileToDownload?.file, fileToDownload?.fileName);
      if (response) {
        toast.success("File download successfully!");
      } else {
        toast.error("File download failed!");
      }
      setLoad(false);
      setFileToDownload({
        file: "",
        fileName: ""
      });
    };
    $[0] = fileToDownload?.file;
    $[1] = fileToDownload?.fileName;
    $[2] = setFileToDownload;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleDownloadFile = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-[18px] sm:text-[20px] font-poppins font-semibold text-[#1F1F1F]">Anti-virus Scan</div>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <rect width="24" height="24" fill="white" />;
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M5.00049 17.5864C4.60999 17.977 4.61005 18.6101 5.00061 19.0006C5.39117 19.3911 6.02433 19.3911 6.41482 19.0005L12.0001 13.4143L17.5858 19C17.9763 19.3905 18.6095 19.3905 19 19C19.3905 18.6095 19.3905 17.9763 19 17.5858L13.4142 12L18.9996 6.41359C19.39 6.02303 19.39 5.38987 18.9994 4.99938C18.6089 4.60888 17.9757 4.60894 17.5852 4.9995L11.9999 10.5858L6.41414 4.99998C6.02362 4.60946 5.39045 4.60946 4.99993 4.99998C4.6094 5.39051 4.6094 6.02367 4.99993 6.4142L10.5859 12.0001L5.00049 17.5864Z" fill="#8E8E8E" />;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onClose) {
    t5 = <div className="flex w-full border-b-2 border-[#E1E1E1] pb-4 justify-between items-center">{t2}<div><svg onClick={onClose} className=" cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">{t3}{t4}</svg></div></div>;
    $[7] = onClose;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Image src="/Images/antivirus-logo.svg" alt="logo" width={80} height={80} />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="w-full flex flex-col flex-1 justify-center pt-5 sm:pt-6 items-center">{t6}<div className="text-center text-[13px] sm:text-[14px] font-medium text-black font-poppins pt-3 sm:pt-4 px-2"><div className="text-center">We've not scanned the file with anti-virus.</div><div className="text-center mt-1">We suggest you to scan in first after downloading the file.</div></div></div>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== handleDownloadFile) {
    t8 = () => handleDownloadFile();
    $[11] = handleDownloadFile;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = !load ? "Proceed to Download" : "Downloading...";
  let t10;
  if ($[13] !== t8 || $[14] !== t9) {
    t10 = <div className="w-full px-0 sm:px-16 pt-5 sm:pt-6 pb-4 sm:pb-0"><button onClick={t8} className="text-white bg-[#354EF0] hover:shadow-lg w-full py-3 sm:py-2.5 rounded-lg font-normal text-[15px] sm:text-[16px] font-poppins">{t9}</button></div>;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t5) {
    t11 = <><div className="fixed inset-0 popup-bg z-50 flex justify-center items-end sm:items-center sm:px-4"><div className="w-full sm:max-w-[450px] h-full sm:h-auto relative bg-white rounded-none sm:rounded-2xl pt-4 px-4 pb-4 shadow sm:border sm:border-neutral-200 flex flex-col">{t5}{t7}{t10}</div></div></>;
    $[16] = t10;
    $[17] = t5;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  return t11;
};
export default AntiVirusScan;